import PopUpComponent from "../PopUpComponent"
import { VisitorBodyPopup } from "./VisitorBodyPopup";

export const VisitorPopUpComponent = (props) => {
    return (
        <>
        <PopUpComponent 
        open = {props.open}
        setOpen = {props.setOpen}
        content = {<VisitorBodyPopup setOpen = {props.setOpen}/>}
        />
        </>
    )
}